module.exports = __webpack_public_path__ + "img/zwsj2.d8f92380.png";